/*******************************************************************************
 * Project：
 * Summary:
 *　　 Action MstHTOrg
 * Remarks:
 *    Define action for MstHTOrg
 * History：
 *      ThaiTV            2022/01/05    Create
 ******************************************************************************/
import { Action } from '@ngrx/store';
import { IMstHTOrg } from 'src/app/models/mstHTOrg.interface';
export enum EMstHTOrgActions {
    GetMstHTOrg = '[IMstHTOrg] Get IMstHTOrg',
}

export class GetIMstHTOrg implements Action {
    public readonly type = EMstHTOrgActions.GetMstHTOrg;
    constructor(public payload: IMstHTOrg) { }
}

export type MstHTOrgActions = GetIMstHTOrg;
